import { Ticket, Boxes, GitMerge, Activity, ShieldAlert, Globe, Headset } from 'lucide-react';
import { IntegrationPage, type IntegrationCapability } from './IntegrationPage';

const capabilities: IntegrationCapability[] = [
  { key: 'tickets', icon: Ticket },
  { key: 'cmdb', icon: Boxes },
  { key: 'correlate', icon: GitMerge },
  { key: 'serviceIntelligence', icon: Activity },
  { key: 'siem', icon: ShieldAlert },
  { key: 'eu', icon: Globe },
];

export function TopdeskIntegrationPage() {
  return (
    <IntegrationPage
      ns="topdeskPage"
      path="/integrations/topdesk"
      heroIcon={Headset}
      accentGradient="from-sky-500 to-sky-400"
      iconColor="text-sky-500"
      iconBg="bg-sky-500/10"
      capabilities={capabilities}
      stepCount={3}
      dataItemCount={8}
      faqKeys={['how', 'sync', 'cost', 'security']}
      docsHref="/docs/pipelines/building-pipelines"
      eventPrefix="topdesk_page"
      relatedLinks={[
        { label: 'Service Intelligence', href: '/service-intelligence' },
        { label: 'Security Monitoring (SIEM)', href: '/siem' },
        { label: 'ServiceNow', href: '/integrations/servicenow' },
        { label: 'Pricing', href: '/pricing' },
      ]}
    />
  );
}
